import api from './api';

/** URL do Collectifile (boardy) – unitresco.collectifile.com w prod */
export const COLLECTIFILE_BOARD_BASE =
  (process.env.REACT_APP_COLLECTIFILE_BOARD_URL as string) || 'https://unitresco.collectifile.com';

export interface MyBoard {
  slug: string;
  name: string;
  projectId: string;
}

export async function getMyBoards(): Promise<MyBoard[]> {
  const res = await api.get<{ success: boolean; data: MyBoard[] }>('/collectifile/my-boards');
  if (!res.data?.success || !Array.isArray(res.data.data)) return [];
  return res.data.data;
}

/** Sprawdza, które projekty/oferty mają boardy w Collectifile */
export async function checkBoardsExist(
  projectIds: string[],
  offerIds: string[] = []
): Promise<{ projectIds: string[]; offerIds: string[] }> {
  try {
    const res = await api.post<{ success: boolean; projectIds: string[]; offerIds: string[] }>(
      '/collectifile/check-boards',
      { projectIds, offerIds }
    );
    if (!res.data?.success) return { projectIds: [], offerIds: [] };
    return {
      projectIds: res.data.projectIds || [],
      offerIds: res.data.offerIds || [],
    };
  } catch {
    return { projectIds: [], offerIds: [] };
  }
}

/** URL do boardu projektu – preferuje manualLink (miro_link), potem collectifile_board_id, na końcu open-or-create */
export function getBoardUrlForProject(
  projectId: string,
  projectName?: string,
  collectifileBoardId?: string | null,
  manualLink?: string | null
): string {
  const base = COLLECTIFILE_BOARD_BASE.replace(/\/$/, '');
  if (manualLink && manualLink.trim()) {
    const t = manualLink.trim();
    if (t.startsWith('http://') || t.startsWith('https://')) return t;
    if (/^[0-9a-f-]{36}$/i.test(t) || /^[a-zA-Z0-9_-]+$/.test(t)) {
      return `${base}/pl/board/${encodeURIComponent(t)}`;
    }
  }
  if (collectifileBoardId && collectifileBoardId.trim()) {
    return `${base}/pl/board/${encodeURIComponent(collectifileBoardId.trim())}`;
  }
  const params = new URLSearchParams();
  params.set('unitrescoProjectId', projectId);
  if (projectName) params.set('name', projectName);
  return `${base}/pl/board/open?${params.toString()}`;
}

/** URL do boardu oferty – preferuje manualLink (miro_link), potem collectifile_board_id, na końcu open-or-create */
export function getBoardUrlForOffer(
  offerId: string,
  collectifileBoardId?: string | null,
  manualLink?: string | null
): string {
  const base = COLLECTIFILE_BOARD_BASE.replace(/\/$/, '');
  if (manualLink && manualLink.trim()) {
    const t = manualLink.trim();
    if (t.startsWith('http://') || t.startsWith('https://')) return t;
    if (/^[0-9a-f-]{36}$/i.test(t) || /^[a-zA-Z0-9_-]+$/.test(t)) {
      return `${base}/pl/board/${encodeURIComponent(t)}`;
    }
  }
  if (collectifileBoardId && collectifileBoardId.trim()) {
    return `${base}/pl/board/${encodeURIComponent(collectifileBoardId.trim())}`;
  }
  const params = new URLSearchParams();
  params.set('offerId', offerId);
  params.set('name', offerId);
  return `${base}/pl/board/open?${params.toString()}`;
}

/** @deprecated Użyj getBoardUrlForProject */
export function getBoardOpenUrlForProject(projectId: string, projectName?: string): string {
  return getBoardUrlForProject(projectId, projectName);
}

/** @deprecated Użyj getBoardUrlForOffer */
export function getBoardOpenUrlForOffer(offerId: string): string {
  return getBoardUrlForOffer(offerId);
}

/** URL do boardu – dla projectId w formacie UUID (istniejący) lub unitresco (otwórz) */
export function getBoardUrl(projectId: string, projectName?: string, collectifileBoardId?: string | null): string {
  const base = COLLECTIFILE_BOARD_BASE.replace(/\/$/, '');
  if (collectifileBoardId && collectifileBoardId.trim()) {
    return `${base}/pl/board/${encodeURIComponent(collectifileBoardId.trim())}`;
  }
  const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(projectId);
  if (isUuid) return `${base}/pl/board/${encodeURIComponent(projectId)}`;
  if (/^OF\./i.test(projectId)) return getBoardUrlForOffer(projectId);
  return getBoardUrlForProject(projectId, projectName);
}
